"use strict";
exports["4d0676db"] = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizSmtpTitleText","properties":{"emailAddress":{"type":"string","title":"LabelEmailAddress","pattern":"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},"serviceInstance":{"type":"string","title":"ServiceSelection","default":"ServiceProduction","enum":["ServiceProduction","Gallatin"],"enumNames":["EOEnvironmentProduction","EOEnvironmentGallatin"]},"proofOfWork":{"type":"string","title":""}},"required":["emailAddress","serviceInstance","proofOfWork"],"$id":"4d0676db"};
const pattern0 = new RegExp("^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$", "u");

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="4d0676db" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.emailAddress === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "emailAddress"},message:"must have required property '"+"emailAddress"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.serviceInstance === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "serviceInstance"},message:"must have required property '"+"serviceInstance"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.proofOfWork === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.emailAddress !== undefined){
let data0 = data.emailAddress;
if(typeof data0 === "string"){
if(!pattern0.test(data0)){
const err3 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/properties/emailAddress/pattern",keyword:"pattern",params:{pattern: "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},message:"must match pattern \""+"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"+"\"",schema:"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$",parentSchema:schema11.properties.emailAddress,data:data0};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/properties/emailAddress/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.emailAddress.type,parentSchema:schema11.properties.emailAddress,data:data0};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.serviceInstance !== undefined){
let data1 = data.serviceInstance;
if(typeof data1 !== "string"){
const err5 = {instancePath:instancePath+"/serviceInstance",schemaPath:"#/properties/serviceInstance/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.serviceInstance.type,parentSchema:schema11.properties.serviceInstance,data:data1};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(!((data1 === "ServiceProduction") || (data1 === "Gallatin"))){
const err6 = {instancePath:instancePath+"/serviceInstance",schemaPath:"#/properties/serviceInstance/enum",keyword:"enum",params:{allowedValues: schema11.properties.serviceInstance.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.serviceInstance.enum,parentSchema:schema11.properties.serviceInstance,data:data1};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data2 = data.proofOfWork;
if(typeof data2 !== "string"){
const err7 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data2};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}
